<template>
  <div class="pre-pare-detail__actions display-flex" :class="{'active': keyActive}">
    <div class="pre-pare-detail__actions__icons">
      <a href="javascript:;" class="item" :class="{'active': keyActive === keyText}" @click="toggleSidebarActions(keyText)">
        <i class="icon-lesson-text"></i>
      </a>
      <a href="javascript:;" class="item" :class="{'active': keyActive === keyShape}" @click="toggleSidebarActions(keyShape)">
        <i class="icon-lesson-shapes"></i>
      </a>
      <a href="javascript:;" class="item" :class="{'active': keyActive === keyPicture}" @click="toggleSidebarActions(keyPicture)">
        <i class="icon-lesson--picture"></i>
      </a>
      <a href="javascript:;" class="item" :class="{'active': keyActive === keyVideo}" @click="toggleSidebarActions(keyVideo)">
        <span class="icon-lesson-video"><span class="path1"></span><span class="path2"></span></span>
      </a>
      <a href="javascript:;" class="item" :class="{'active': keyActive === keyAudio}" @click="toggleSidebarActions(keyAudio)">
        <i class="icon-lesson-audio"></i>
      </a>
      <a href="javascript:;" class="item" :class="{'active': keyActive === keySlide}" @click="toggleSidebarActions(keySlide)">
        <span class="icon-lesson-slide"><span class="path1"></span><span class="path2"></span></span>
      </a>
    </div>
    <div class="pre-pare-detail__actions__detail color_bg_gray_light">
      <SidebarActionText v-show="keyActive === keyText" :keyActive="keyActive" />
      <SidebarActionShape v-show="keyActive === keyShape" :keyActive="keyActive" />
      <SidebarActionImg v-show="keyActive === keyPicture" :keyActive="keyActive" />
      <SidebarActionVideo v-show="keyActive === keyVideo" :keyActive="keyActive" />
      <SidebarActionAudio v-show="keyActive === keyAudio" :keyActive="keyActive" />
      <SidebarActionPowerpoint v-show="keyActive === keySlide" :keyActive="keyActive" />
    </div>
    <!-- <ModalPreviewMedia v-if="indexPreviewMedia > -1" :keySidebar="keyActive" /> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SidebarActionText from './SidebarActionText.vue'
import SidebarActionShape from './SidebarActionShape.vue'
import SidebarActionImg from './SidebarActionImg.vue'
import SidebarActionVideo from './SidebarActionVideo.vue'
import SidebarActionAudio from './SidebarActionAudio.vue'
import SidebarActionPowerpoint from './SidebarActionPowerpoint.vue'
import { STORE_KEY, KEY_TXT, KEY_SHAPE, KEY_PICTURE, KEY_VIDEO, KEY_AUDIO, KEY_SLIDE } from './../../_store/constants'

export default {
  name: 'SidebarActions',
  props: {
    closeActionSidebar: Boolean
  },
  components: {
    SidebarActionText,
    SidebarActionShape,
    SidebarActionImg,
    SidebarActionVideo,
    SidebarActionAudio,
    SidebarActionPowerpoint
  },
  data () {
    return {
      keyActive: '', //Keys: text, shape, picture, video, audio, slide
      keyText: KEY_TXT,
      keyShape: KEY_SHAPE,
      keyPicture: KEY_PICTURE,
      keyVideo: KEY_VIDEO,
      keyAudio: KEY_AUDIO,
      keySlide: KEY_SLIDE
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['indexPreviewMedia'])
  },
  watch: {
    closeActionSidebar (newVal) {
      if (newVal) {
        this.keyActive = ''
      }
    },

    keyActive () {
      this.acSetMediaPreview([])
    }
  },
  mounted () {
    this.toggleSidebarActions('text')
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetMediaPreview', 'acSetkeySidebarVisible']),

    toggleSidebarActions (key) {
      this.$emit('toggleActions', this.keyActive === key ? false : true)
      this.keyActive = this.keyActive === key ? '' : key
      // Set key sidebar to state
      this.acSetkeySidebarVisible(this.keyActive === key ? '' : key)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>